// 中间页；验证之后跳转到后端返回页面
<template>
  <el-dialog
    title="提示"
    top="30vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="dialogVisible"
    width="30%">
    <el-input placeholder="请输入验证码" v-model="vcode">
      <template slot="prepend">验证码：</template>
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="verification">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
// API
import {ApiMethods} from "@/assets/js/http-serve/http-methods";
// tool
import { isInDingTalk } from "@/assets/js/utils/ding-env";

  export default {
    layout: "fullpage",
    data () {
      // 这里存放数据
      return {
        vcode:'',
        dialogVisible: true,
        loading: null
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      verification () {
        if(!this.vcode) return this.$message.error('请输入验证码')
        this.loadingStart();
        const param= {
          code: this.vcode,
          applyNo:this.$route.query.applyNo
        }
        ApiMethods.CertiController.redirectToInfo(param).then(res=>{
          if(!res.success) {
            return this.$message.error(res.description)
          }
          isInDingTalk ? location.href=res.data : window.open(res.data)
        }).finally(()=>{
          this.dialogVisible=false;
          this.loadingClose();
        });
      },
      loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>

<style lang='less' scoped>
</style>


// WEBPACK FOOTER //
// pages/applySign/middle.vue